import { render, staticRenderFns } from "./ProductoListaItemTalle.vue?vue&type=template&id=7e49b050&"
import script from "./ProductoListaItemTalle.vue?vue&type=script&lang=js&"
export * from "./ProductoListaItemTalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports